import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 查询预支付单详情
export default async function orderCheckoutDetails(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/checkout/details', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
